export const BOND_OF_INTEREST_ACTIONS = {
  GET_BOND_OF_INTEREST_RESPONSE: 'GET_BOND_OF_INTEREST_RESPONSE',
  GET_BOND_OF_INTEREST_REQUEST: 'GET_BOND_OF_INTEREST_REQUEST',
  GET_BOND_OF_INTEREST_ERROR: 'GET_BOND_OF_INTEREST_ERROR',
};

export const BOND_TRENDING_FLAG_ACTIONS = {
  GET_TRENDING_FLAG_RESPONSE: 'GET_TRENDING_FLAG_RESPONSE',
  GET_TRENDING_FLAG_REQUEST: 'GET_TRENDING_FLAG_REQUEST',
  GET_TRENDING_FLAG_ERROR: 'GET_TRENDING_FLAG_ERROR',
};
export const BOND_RCENETPRICE_ACTIONS = {
  GET_RCENETPRICE_RESPONSE: 'GET_RCENETPRICE_RESPONSE',
  GET_RCENETPRICE_REQUEST: 'GET_RCENETPRICE_REQUEST',
  GET_RCENETPRICE_ERROR: 'GET_RCENETPRICE_ERROR',
};
export const BOND_FOLLOWEDBYUSER_ACTIONS = {
  GET_FOLLOWEDBYUSER_RESPONSE: 'GET_FOLLOWEDBYUSER_RESPONSE',
  GET_FOLLOWEDBYUSER_REQUEST: 'GET_FOLLOWEDBYUSER_REQUEST',
  GET_FOLLOWEDBYUSER_ERROR: 'GET_FOLLOWEDBYUSER_ERROR',
};
export const POSITION_AND_FOLLOWED_BOND_BY_USER_ACTIONS = {
  POSITION_AND_FOLLOWED_BOND_BY_USER_RESPONSE: 'POSITION_AND_FOLLOWED_BOND_BY_USER_RESPONSE',
  POSITION_AND_FOLLOWED_BOND_BY_USER_REQUEST: 'POSITION_AND_FOLLOWED_BOND_BY_USER_REQUEST',
  POSITION_AND_FOLLOWED_BOND_BY_USER_ERROR: 'POSITION_AND_FOLLOWED_BOND_BY_USER_ERROR',
};
export const POSITION_BONDS_BY_USER_ACTIONS = {
  POSITION_BONDS_BY_USER_RESPONSE: 'POSITION_BONDS_BY_USER_RESPONSE',
  POSITION_BONDS_BY_USER_REQUEST: 'POSITION_BONDS_BY_USER_REQUEST',
  POSITION_BONDS_BY_USER_ERROR: 'POSITION_BONDS_BY_USER_ERROR',
};

export const BOND_PRICE_CHARTS_ACTIONS = {
  GET_BOND_PRICE_CHARTS_RESPONSE: 'GET_BOND_PRICE_CHARTS_RESPONSE',
  GET_BOND_PRICE_CHARTS_REQUEST: 'GET_BOND_PRICE_CHARTS_REQUEST',
  GET_BOND_PRICE_CHARTS_ERROR: 'GET_BOND_PRICE_CHARTS_ERROR',
};

export const MARK_AS_DEFAULT_GRAPH_ACTIONS = {
  GET_MARK_AS_DEFAULT_GRAPH_RESPONSE: 'GET_MARK_AS_DEFAULT_GRAPH_RESPONSE',
  GET_MARK_AS_DEFAULT_GRAPH_REQUEST: 'GET_MARK_AS_DEFAULT_GRAPH_REQUEST',
  GET_MARK_AS_DEFAULT_GRAPH_ERROR: 'GET_MARK_AS_DEFAULT_GRAPH_ERROR',
};
export const FEATURED_SEARCH_ACTIONS = {
  GET_FEATURED_SEARCH_RESPONSE: 'GET_FEATURED_SEARCH_RESPONSE',
  GET_FEATURED_SEARCH_REQUEST: 'GET_FEATURED_SEARCH_REQUEST',
  GET_FEATURED_SEARCH_ERROR: 'GET_FEATURED_SEARCH_ERROR',
};
export const FILTER_LIST_DELETE_ACTIONS = {
  FILTER_LIST_DELETE_RESPONSE: 'FILTER_LIST_DELETE_RESPONSE',
  FILTER_LIST_DELETE_REQUEST: 'FILTER_LIST_DELETE_REQUEST',
  FILTER_LIST_DELETE_ERROR: 'FILTER_LIST_DELETE_ERROR',
};

